import { Inject, Injectable, PLATFORM_ID, Renderer2, RendererFactory2 } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  public renderer: Renderer2 | null = null;
  public isBrowser: boolean = false;
  countries: any[] = [
    { code: 'AF', dialCode: '+93', flag: '🇦🇫', name: 'Afghanistan' },
    { code: 'AL', dialCode: '+355', flag: '🇦🇱', name: 'Albania' },
    { code: 'DZ', dialCode: '+213', flag: '🇩🇿', name: 'Algeria' },
    { code: 'AD', dialCode: '+376', flag: '🇦🇩', name: 'Andorra' },
    { code: 'AO', dialCode: '+244', flag: '🇦🇴', name: 'Angola' },
    { code: 'AR', dialCode: '+54', flag: '🇦🇷', name: 'Argentina' },
    { code: 'AM', dialCode: '+374', flag: '🇦🇲', name: 'Armenia' },
    { code: 'AU', dialCode: '+61', flag: '🇦🇺', name: 'Australia' },
    { code: 'AT', dialCode: '+43', flag: '🇦🇹', name: 'Austria' },
    { code: 'AZ', dialCode: '+994', flag: '🇦🇿', name: 'Azerbaijan' },
    { code: 'BH', dialCode: '+973', flag: '🇧🇭', name: 'Bahrain' },
    { code: 'BD', dialCode: '+880', flag: '🇧🇩', name: 'Bangladesh' },
    { code: 'BE', dialCode: '+32', flag: '🇧🇪', name: 'Belgium' },
    { code: 'BR', dialCode: '+55', flag: '🇧🇷', name: 'Brazil' },
    { code: 'CA', dialCode: '+1', flag: '🇨🇦', name: 'Canada' },
    { code: 'CN', dialCode: '+86', flag: '🇨🇳', name: 'China' },
    { code: 'CO', dialCode: '+57', flag: '🇨🇴', name: 'Colombia' },
    { code: 'CU', dialCode: '+53', flag: '🇨🇺', name: 'Cuba' },
    { code: 'CZ', dialCode: '+420', flag: '🇨🇿', name: 'Czech Republic' },
    { code: 'DK', dialCode: '+45', flag: '🇩🇰', name: 'Denmark' },
    { code: 'EG', dialCode: '+20', flag: '🇪🇬', name: 'Egypt' },
    { code: 'FI', dialCode: '+358', flag: '🇫🇮', name: 'Finland' },
    { code: 'FR', dialCode: '+33', flag: '🇫🇷', name: 'France' },
    { code: 'DE', dialCode: '+49', flag: '🇩🇪', name: 'Germany' },
    { code: 'GR', dialCode: '+30', flag: '🇬🇷', name: 'Greece' },
    { code: 'HK', dialCode: '+852', flag: '🇭🇰', name: 'Hong Kong' },
    { code: 'HU', dialCode: '+36', flag: '🇭🇺', name: 'Hungary' },
    { code: 'IN', dialCode: '+91', flag: '🇮🇳', name: 'India' },
    { code: 'ID', dialCode: '+62', flag: '🇮🇩', name: 'Indonesia' },
    { code: 'IR', dialCode: '+98', flag: '🇮🇷', name: 'Iran' },
    { code: 'IQ', dialCode: '+964', flag: '🇮🇶', name: 'Iraq' },
    { code: 'IE', dialCode: '+353', flag: '🇮🇪', name: 'Ireland' },
    { code: 'IL', dialCode: '+972', flag: '🇮🇱', name: 'Israel' },
    { code: 'IT', dialCode: '+39', flag: '🇮🇹', name: 'Italy' },
    { code: 'JP', dialCode: '+81', flag: '🇯🇵', name: 'Japan' },
    { code: 'JO', dialCode: '+962', flag: '🇯🇴', name: 'Jordan' },
    { code: 'KZ', dialCode: '+7', flag: '🇰🇿', name: 'Kazakhstan' },
    { code: 'KE', dialCode: '+254', flag: '🇰🇪', name: 'Kenya' },
    { code: 'KR', dialCode: '+82', flag: '🇰🇷', name: 'South Korea' },
    { code: 'KW', dialCode: '+965', flag: '🇰🇼', name: 'Kuwait' },
    { code: 'LB', dialCode: '+961', flag: '🇱🇧', name: 'Lebanon' },
    { code: 'MY', dialCode: '+60', flag: '🇲🇾', name: 'Malaysia' },
    { code: 'MX', dialCode: '+52', flag: '🇲🇽', name: 'Mexico' },
    { code: 'MA', dialCode: '+212', flag: '🇲🇦', name: 'Morocco' },
    { code: 'NL', dialCode: '+31', flag: '🇳🇱', name: 'Netherlands' },
    { code: 'NZ', dialCode: '+64', flag: '🇳🇿', name: 'New Zealand' },
    { code: 'NG', dialCode: '+234', flag: '🇳🇬', name: 'Nigeria' },
    { code: 'NO', dialCode: '+47', flag: '🇳🇴', name: 'Norway' },
    { code: 'PK', dialCode: '+92', flag: '🇵🇰', name: 'Pakistan' },
    { code: 'PH', dialCode: '+63', flag: '🇵🇭', name: 'Philippines' },
    { code: 'PL', dialCode: '+48', flag: '🇵🇱', name: 'Poland' },
    { code: 'PT', dialCode: '+351', flag: '🇵🇹', name: 'Portugal' },
    { code: 'QA', dialCode: '+974', flag: '🇶🇦', name: 'Qatar' },
    { code: 'RU', dialCode: '+7', flag: '🇷🇺', name: 'Russia' },
    { code: 'SA', dialCode: '+966', flag: '🇸🇦', name: 'Saudi Arabia' },
    { code: 'SG', dialCode: '+65', flag: '🇸🇬', name: 'Singapore' },
    { code: 'ZA', dialCode: '+27', flag: '🇿🇦', name: 'South Africa' },
    { code: 'ES', dialCode: '+34', flag: '🇪🇸', name: 'Spain' },
    { code: 'LK', dialCode: '+94', flag: '🇱🇰', name: 'Sri Lanka' },
    { code: 'SE', dialCode: '+46', flag: '🇸🇪', name: 'Sweden' },
    { code: 'CH', dialCode: '+41', flag: '🇨🇭', name: 'Switzerland' },
    { code: 'TH', dialCode: '+66', flag: '🇹🇭', name: 'Thailand' },
    { code: 'TR', dialCode: '+90', flag: '🇹🇷', name: 'Turkey' },
    { code: 'AE', dialCode: '+971', flag: '🇦🇪', name: 'United Arab Emirates' },
    { code: 'GB', dialCode: '+44', flag: '🇬🇧', name: 'United Kingdom' },
    { code: 'US', dialCode: '+1', flag: '🇺🇸', name: 'United States' },
    { code: 'VN', dialCode: '+84', flag: '🇻🇳', name: 'Vietnam' },
    { code: 'YE', dialCode: '+967', flag: '🇾🇪', name: 'Yemen' },
    { code: 'ZW', dialCode: '+263', flag: '🇿🇼', name: 'Zimbabwe' }
  ];
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private rendererFactory: RendererFactory2,  // Use RendererFactory2 for lazy initialization
    public toaster: ToastrService,
    public spinner: NgxSpinnerService
  ) {
    this.isBrowser = isPlatformBrowser(platformId);

    // Initialize Renderer2 only in browser
    if (this.isBrowser) {
      this.renderer = this.rendererFactory.createRenderer(null, null);
    }
  }

  removeTag(): void {
    if (this.isBrowser) {
      const pageMetaSelectors = [
        'meta[name="title"]',
        'meta[name="description"]',
        'meta[name="keywords"]',
        'meta[name="author"]',
        'meta[name="robots"]',
        'meta[name="googlebot"]',
        'meta[property^="og:"]',
        'meta[name^="twitter:"]',
        'meta[property^="twitter:"]'
      ];

      document.querySelectorAll(pageMetaSelectors.join(',')).forEach(tag => tag.remove());
      document.querySelectorAll('link[rel="canonical"]').forEach(link => link.remove());
    }
  }

}
